import {create} from 'zustand';

interface KeyboardState {
    isKeyboardOpen: boolean;
    setKeyboardOpen: (open: boolean) => void;
}

export const useKeyboardStore = create<KeyboardState>(set => ({
    isKeyboardOpen: false,
    setKeyboardOpen: open => set({isKeyboardOpen: open}),
}));
